import classnames from 'classnames'
import React from 'react'

import * as styles from './index.module.scss'

type ErrorMessageProps = {
  message?: string
  hasError: boolean
  className?: string
}

export const ErrorMessage = (props: ErrorMessageProps): JSX.Element | null => {
  if (!props.hasError) {
    return null
  }

  const errorStyles = 'filterSummary__error'

  return (
    <>
      <div className={classnames(styles[errorStyles], props.className)}>{props.message}</div>
    </>
  )
}
